module.exports = __webpack_public_path__ + "static/media/main10.bc964697.jpeg";